/* v8 ignore start */
import {LottieLayerType} from "@/lib/lottie/layers/lottieLayerType";
import {LottieVisualLayerModel} from "@/lib/lottie/layers/lottieVisualLayerModel";
import {NumberUtils} from "@/lib/utils/numberUtils";

export type TRGB = [number, number, number];

export class LottieShapeLayerModel extends LottieVisualLayerModel<LottieShapeLayerModel.IJson> {
  public static buildGradientLayer(colors: TRGB[], durationInFrames: number): LottieShapeLayerModel {
    const colorCount = colors.length;

    // FIXME: Does not have support for portrait
    return new LottieShapeLayerModel({
      ddd: 0,
      ind: 2,
      ty: 4,
      nm: "Background Gradient",
      sr: 1,
      ks: {
        o: {a: 0, k: 100, ix: 11},
        r: {a: 0, k: 0, ix: 10},
        p: {a: 0, k: [960, 540, 0], ix: 2, l: 2},
        a: {a: 0, k: [0, 0, 0], ix: 1, l: 2},
        s: {a: 0, k: [100, 100, 100], ix: 6, l: 2},
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ty: "rc",
              d: 1,
              s: {a: 0, k: [1920, 1080], ix: 2},
              p: {a: 0, k: [0, 0], ix: 3},
              r: {a: 0, k: 0, ix: 4},
              nm: "Rectangle Path 1",
              mn: "ADBE Vector Shape - Rect",
              hd: false,
            },
            {
              ty: "tr",
              p: {a: 0, k: [0, 0], ix: 2},
              a: {a: 0, k: [0, 0], ix: 1},
              s: {a: 0, k: [100, 100], ix: 3},
              r: {a: 0, k: 0, ix: 6},
              o: {a: 0, k: 100, ix: 7},
              sk: {a: 0, k: 0, ix: 4},
              sa: {a: 0, k: 0, ix: 5},
              nm: "Transform",
            },
          ],
          nm: "Rectangle 1",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
        {
          ty: "gf",
          o: {a: 0, k: 100, ix: 10},
          r: 2,
          bm: 0,
          g: {
            p: colorCount,
            k: {
              a: 0,
              k: this.generateLottieGradient(colors),
              ix: 9,
            },
          },
          s: {a: 0, k: [0, 0], ix: 5},
          e: {a: 0, k: [1920, 0], ix: 6},
          t: 1,
          nm: "Gradient Fill 1",
          mn: "ADBE Vector Graphic - G-Fill",
          hd: false,
        },
      ],
      ip: 0,
      op: durationInFrames,
      st: 0,
      bm: 0,
    });
  }

  private static generateLottieGradient(colors: TRGB[]) {
    const k = [];
    const numColors = colors.length;

    for (let i = 0; i < numColors; i++) {
      const position = i / (numColors - 1);

      k.push(position);

      k.push(NumberUtils.round(colors[i][0] / 255, 2));
      k.push(NumberUtils.round(colors[i][1] / 255, 2));
      k.push(NumberUtils.round(colors[i][2] / 255, 2));
    }

    return k;
  }
}

export namespace LottieShapeLayerModel {
  export interface IJson extends LottieVisualLayerModel.IJson {
    /**
     * Layer type
     */
    ty: LottieLayerType.Shape;

    /**
     * Shape
     */
    shapes: any; // TODO: Add typings
  }
}
/* v8 ignore stop */
